declare let globalLanguage: string;
let currentLanguage = globalLanguage || "nl";

const translations = {

    nl: {"companionsPicker_Button_CustomButton":"Zoeken","companionsPicker_Label_NumberOfBabies":"Baby\u0027s","companionsPicker_Label_NumberOfPersons":"Personen","companionsPicker_Label_NumberOfPets":"Huisdieren","companionsPicker_Title_Between_0_2_years":"Tussen 0 - 2 jaar","companionsPicker_Title_ChooseCompany":"Kies gezelschap"},
    en: {"companionsPicker_Button_CustomButton":"Search","companionsPicker_Label_NumberOfBabies":"Babies","companionsPicker_Label_NumberOfPersons":"Persons","companionsPicker_Label_NumberOfPets":"Pets","companionsPicker_Title_Between_0_2_years":"Between 0 - 2 years","companionsPicker_Title_ChooseCompany":"Choose company"},
    de: {"companionsPicker_Button_CustomButton":"Suchen","companionsPicker_Label_NumberOfBabies":"Babys","companionsPicker_Label_NumberOfPersons":"Personen","companionsPicker_Label_NumberOfPets":"Haustiere","companionsPicker_Title_Between_0_2_years":"Zwischen 0 - 2 Jahren","companionsPicker_Title_ChooseCompany":"Reisegruppe ausw\u00E4hlen"}
};

interface appTranslations {

    companionsPicker_Button_CustomButton: string; 
    companionsPicker_Label_NumberOfBabies: string; 
    companionsPicker_Label_NumberOfPersons: string; 
    companionsPicker_Label_NumberOfPets: string; 
    companionsPicker_Title_Between_0_2_years: string; 
    companionsPicker_Title_ChooseCompany: string; 

}

//@ts-ignore
let currentTranslation = (currentLanguage in translations) ? translations[currentLanguage] : translations["nl"];

export default currentTranslation as appTranslations;